import { createContext } from 'react';

const PusherContext = createContext();

export default PusherContext;
